import React, { useEffect, useMemo, useRef, useState } from 'react';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import SearchContainer from '@/screens/Appointments/SearchContainer';
import CustomSwitch from '@/components/CostomSwitch/CustomSwitch';
import PageContainerTabs from '@/components/PageContainerTabs';
import LoadingV2 from '@/components/Loading';
import { LiveUnloadPlannerTab } from './LiveUnloadPlannerTab';
import { DropPickPlannerTab } from './DropPickPlannerTab';
import { IssuesPlannerTab } from './IssuesPlannerTab';
import { PlannerSummaryStrip } from './PlannerSummaryStrip';
import liveUnloadPlannerTestData from './data/liveUnloadPlannerTestData';
import dropPickPlannerTestData from './data/dropPickPlannerTestData';
import issuesPlannerTestData from './data/issuesPlannerTestData';
import { filterPlannerPool } from './plannerListFilters';
import {
  computeJobTabStats,
  computeIssuesTabStats,
} from './plannerSummaryStats';
import styles from './plannerPage.module.css';
import { useLocation } from 'react-router-dom';

/** Order matches PageContainerTabs row-reverse: first item is rightmost tab. */
const PLANNER_TAB_LINKS = [
  // { title: 'Issues', pushAddress: 'issues', width: 88 },
  { title: 'Live Unload Planner', pushAddress: 'live_unload', width: 210 },
  // { title: 'Drop & Pick Planner', pushAddress: 'drop_pick', width: 200 },
];

const SUBTITLE =
  'Corrected planner where Live Unload Uses unloading time and Drop & Pick uses buffer time.';

/** How long the tab panel overlay stays visible after the last distance slider change. */
const DISTANCE_FILTER_LOADING_MS = 420;

export default function AutobookPlannerPage() {
  const location = useLocation();
  const initialContainerName = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('containerName') || '';
  }, [location.search]);

  const returnAppointmentHref = '';
  const filterContainerName = '';
  const [plannerSearchTerm, setPlannerSearchTerm] = useState(
    initialContainerName
  );

  useEffect(() => {
    setPlannerSearchTerm(initialContainerName);
  }, [initialContainerName]);
  const [allowSameCity, setAllowSameCity] = useState(true);
  const [distanceMi, setDistanceMi] = useState(25);
  const [activeTab, setActiveTab] = useState('live_unload');
  const [distanceFilterLoading, setDistanceFilterLoading] = useState(false);
  const skipFirstDistanceEffect = useRef(true);
  const distanceLoadingTimerRef = useRef(null);

  const rangeBackground = useMemo(() => {
    const pct = (distanceMi / 1000) * 100;
    return `linear-gradient(to right, #131517 0%, #131517 ${pct}%, #e5e7eb ${pct}%, #e5e7eb 100%)`;
  }, [distanceMi]);

  useEffect(() => {
    if (skipFirstDistanceEffect.current) {
      skipFirstDistanceEffect.current = false;
      return undefined;
    }
    if (distanceLoadingTimerRef.current) {
      clearTimeout(distanceLoadingTimerRef.current);
    }
    setDistanceFilterLoading(true);
    distanceLoadingTimerRef.current = setTimeout(() => {
      setDistanceFilterLoading(false);
      distanceLoadingTimerRef.current = null;
    }, DISTANCE_FILTER_LOADING_MS);
    return () => {
      if (distanceLoadingTimerRef.current) {
        clearTimeout(distanceLoadingTimerRef.current);
        distanceLoadingTimerRef.current = null;
      }
    };
  }, [distanceMi]);

  const filteredDropPick = useMemo(
    () =>
      filterPlannerPool(dropPickPlannerTestData, distanceMi, plannerSearchTerm),
    [distanceMi, plannerSearchTerm]
  );

  const filteredLiveUnload = useMemo(
    () =>
      filterPlannerPool(
        liveUnloadPlannerTestData,
        distanceMi,
        plannerSearchTerm
      ),
    [distanceMi, plannerSearchTerm]
  );

  const filteredIssues = useMemo(
    () =>
      filterPlannerPool(issuesPlannerTestData, distanceMi, plannerSearchTerm),
    [distanceMi, plannerSearchTerm]
  );

  const summaryStats = useMemo(() => {
    if (activeTab === 'issues') {
      return computeIssuesTabStats(filteredIssues);
    }
    if (activeTab === 'live_unload') {
      return computeJobTabStats(filteredLiveUnload);
    }
    return computeJobTabStats(filteredDropPick);
  }, [activeTab, filteredDropPick, filteredLiveUnload, filteredIssues]);

  return (
    <PageContainerAB
      title="Autobook Planner"
      subtitle={SUBTITLE}
      mainPage
      minWidth="unset">
      <div className="mt-6 flex w-full min-w-0 max-w-full flex-col gap-6 pb-8">
        <div className={styles.searchAndSummaryRow}>
          <div className={styles.searchWrap}>
            <SearchContainer
              setContainerName={setPlannerSearchTerm}
              width="300px"
              placeholder="Search Container Number..."
              initialQuery={initialContainerName}
            />
          </div>
          {/* <PlannerSummaryStrip
            total={summaryStats.total}
            booked={summaryStats.booked}
            pending={summaryStats.pending}
            failed={summaryStats.failed}
          /> */}
        </div>

        {/* <div className="grid w-full min-w-0 max-w-full grid-cols-1 gap-4 lg:grid-cols-2">
          <div className={styles.card}>
            <div className={styles.toggleRow}>
              <div>
                <h2 className={styles.cardTitle}>Allow Same City Matching</h2>
                <p className={styles.cardSub}>
                  Use another warehouse in the same city if no local empty is
                  found.
                </p>
              </div>
              <CustomSwitch
                checked={allowSameCity}
                onChange={setAllowSameCity}
              />
            </div>
          </div>

          <div className={`${styles.card} ${styles.cardColumn}`}>
            <p className={styles.sliderLabel}>Distance Limit</p>
            <div className={styles.sliderRow}>
              <input
                type="range"
                min={0}
                max={1000}
                step={1}
                value={distanceMi}
                onChange={(e) => setDistanceMi(Number(e.target.value))}
                className={styles.range}
                style={{ background: rangeBackground }}
                aria-valuemin={0}
                aria-valuemax={1000}
                aria-valuenow={distanceMi}
              />
              <span className={styles.sliderValue}>{distanceMi} mi</span>
            </div>
          </div>
        </div> */}

        <div className={styles.plannerTabsWrap}>
          <PageContainerTabs
            titlesLinks={PLANNER_TAB_LINKS}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            baseAddress="/autoBook/planner/"
            skipHistory
          />
        </div>

        <div
          className={styles.tabPanel}
          role="tabpanel"
          id={`planner-panel-${activeTab}`}
          aria-busy={distanceFilterLoading}>
          {distanceFilterLoading ? (
            <div
              className={styles.tabPanelLoadingOverlay}
              aria-live="polite"
              aria-label="Applying distance filter">
              <LoadingV2 />
            </div>
          ) : null}
          {activeTab === 'drop_pick' ? (
            <DropPickPlannerTab
              distanceLimitMi={distanceMi}
              containerSearch={plannerSearchTerm}
              returnAppointmentHref={returnAppointmentHref}
              filterContainerName={filterContainerName}
            />
          ) : null}
          {activeTab === 'live_unload' ? (
            <LiveUnloadPlannerTab
              distanceLimitMi={distanceMi}
              containerSearch={plannerSearchTerm}
              returnAppointmentHref={returnAppointmentHref}
              filterContainerName={filterContainerName}
            />
          ) : null}
          {activeTab === 'issues' ? (
            <IssuesPlannerTab
              distanceLimitMi={distanceMi}
              containerSearch={plannerSearchTerm}
            />
          ) : null}
        </div>
      </div>
    </PageContainerAB>
  );
}
